import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  DatePicker,
  Col,
  RadioGroup,
  Radio,
  Input,
  Uploader,
  Message,
  Icon,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled, isImageOrPdf } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import moment from 'moment'
import ScrutinizeAttachFiles from './ScrutinizeAttachFiles'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'

export default function ScrutinizeMethodFom({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onDownload,
  onPreview,
  isMeetingResult,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [scrutinizeMethod, setScrutinizeMethod] = useState(_schema?.scrutinizeMethod?.value)
  const [deleteFileList, setDeleteFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])

  useEffect(() => {
    setSchema(_schema)
    setScrutinizeMethod(_schema?.scrutinizeMethod?.value)
    setAttachFiles(_schema?.attachFiles?.values || [])
  }, [_schema])

  const onDeleteFile = (rowData, index) => {
    let attachList = cloneDeep(attachFiles)
    attachList.splice(index, 1)
    let deleteList = deleteFileList || []
    deleteList.push(rowData.deleteId)

    setAttachFiles(attachList)
    setDeleteFileList(deleteList)
    setValue('deleteFileList', deleteList)
  }

  return (
    <Panel>
      <Row>
        {schema.scrutinizeMethod && !isMeetingResult && (
          <Col>
            <ErrorMessage error={errors[schema.scrutinizeMethod.name]} />
            {/* <p>
              {requiredFiled(schema.scrutinizeMethod.validators, schema.scrutinizeMethod.label)}
            </p> */}
            <Controller
              key={schema.scrutinizeMethod.name}
              name={schema.scrutinizeMethod.name}
              control={control}
              defaultValue={scrutinizeMethod}
              render={(props) => {
                return (
                  <RadioGroup
                    value={scrutinizeMethod}
                    inline
                    onChange={(e) => {
                      props.onChange(e)
                      setScrutinizeMethod(e)
                    }}
                  >
                    {schema.scrutinizeMethod.options.map((item) => {
                      return (
                        <Radio
                          key={'radio_' + item.value}
                          value={item.value}
                          disabled={isMeetingResult}
                        >
                          {item.label}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        )}

        {scrutinizeMethod == '2' && (
          <div>
            {schema.meettingName && (
              <Row style={{ marginTop: 10 }}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ErrorMessage error={errors[schema.meettingName.name]} />
                  <p>{requiredFiled(schema.meettingName.validators, schema.meettingName.label)}</p>
                  <Input
                    name={schema.meettingName.name}
                    defaultValue={schema.meettingName.value}
                    placeholder={schema.meettingName.hint || `ระบุ${schema.meettingName.label}`}
                    inputRef={register(isValidators(schema.meettingName.validators))}
                  />
                </Col>
              </Row>
            )}

            {schema.meettingDate && (
              <Row style={{ marginTop: 10 }}>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ErrorMessage error={errors[schema.meettingDate.name]} />
                  <p>{requiredFiled(schema.meettingDate.validators, schema.meettingDate.label)}</p>
                  <Controller
                    key={schema.meettingDate.name}
                    name={schema.meettingDate.name}
                    control={control}
                    rules={isValidators(schema.meettingDate.validators)}
                    defaultValue={
                      schema.meettingDate.value
                      // ? moment(schema.meettingDate.value, DATE_FORMAT).toDate()
                      // : null
                    }
                    render={(props) => {
                      return (
                        <DatePicker
                          size="lg"
                          block
                          locale={LOCAL_DAY_TH}
                          format={DATE_PICKER_FORMAT}
                          // appearance="subtle"
                          placement="auto"
                          value={props.value}
                          onChange={(value) => {
                            let date
                            value && (date = value.toLocaleDateString('en-ZA'))
                            props.onChange(date)
                          }}
                          onClean={() => {
                            props.onChange('')
                          }}
                          // disabledDate={(date) => date < new Date()}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
            )}

            {schema.attachFiles && (
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <ErrorMessage error={errors[schema.attachFiles.name]} />
                  <p>{requiredFiled(schema.attachFiles.validators, schema.attachFiles.label)}</p>
                  {fileTypeError && (
                    <Message
                      closable
                      onClose={() => {
                        setFileTypeError(false)
                      }}
                      showIcon
                      type="error"
                      description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
                    />
                  )}
                  <Controller
                    key={schema.attachFiles.name}
                    name={schema.attachFiles.name}
                    control={control}
                    rules={isValidators(schema.attachFiles.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          autoUpload={false}
                          disabled={schema.attachFiles.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let file = fileList[fileList.length - 1]

                              if (isImageOrPdf(file.blobFile.type)) {
                                props.onChange(fileList)
                                setFileTypeError(false)
                              } else {
                                setFileTypeError(true)
                              }
                            }
                          }}
                          draggable
                        >
                          <div style={{ lineHeight: '100px' }}>
                            <Icon size="4x" icon="upload2" />
                            <small
                              style={{
                                marginTop: '-70px',
                                display: 'block',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </small>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
                <Col>
                  <Controller
                    key={'deleteFileList'}
                    name={'deleteFileList'}
                    control={control}
                    defaultValue={deleteFileList}
                  />
                  <ScrutinizeAttachFiles
                    data={attachFiles || []}
                    onDownload={onDownload}
                    onPreview={onPreview}
                    onDelete={onDeleteFile}
                    isEdit={true}
                  ></ScrutinizeAttachFiles>
                </Col>
              </Row>
            )}
          </div>
        )}
      </Row>
    </Panel>
  )
}
